import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { MyAccountPermissionsAuthGuard } from '../../myaccount/guards/myaccount-permissions-auth.guard';
import { CheckoutCartIsValidatedGuard } from '../guards/checkout-cart-validated-guard';
import { CheckoutPaymentDetailsComponent } from './checkout-payment-details.component';

@NgModule({
  imports: [CommonModule, I18nModule, CheckoutPaymentDetailsComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutPaymentDetails: {
          component: CheckoutPaymentDetailsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutCartIsValidatedGuard, MyAccountPermissionsAuthGuard],
        },
      },
    }),
  ],
  exports: [CheckoutPaymentDetailsComponent],
})
export class CheckoutPaymentDetailsModule {}
